import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { from } from 'rxjs';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { CompanyService } from 'src/app/services/company.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';
import { companiesService } from 'src/app/shared/vive-api/companies.service';

@Component({
  selector: 'app-admin-client-vendors',
  templateUrl: './admin-client-vendors.component.html',
  styleUrls: ['./admin-client-vendors.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminClientVendorsComponent {
  constructor(
    private CompanyService: CompanyService,
    private SharedDataService: SharedDataService,
    private router: Router,
    private ToastService: ToastService
  ) {
    this.SharedDataService.listenForEvent<number>().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'SetCompanyId' && typeof data === 'number') {
          this.CompanyId = data;

          Object.assign(this.SuppliedQueryData, { CompanyId: this.CompanyId });

          from(
            companiesService.findOneById({
              pathParams: { companyId: this.CompanyId }
            })
          ).subscribe({
            next: (Company) => {
              const { legalName } = Company;
              this.SharedDataService.sendEvent(
                'SetTitle',
                `Vendors - ${legalName}`
              );
            }
          });
        }
      }
    });

    this.SharedDataService.sendEvent('GetCompanyId');
  }

  CompanyId?: number;
  SuppliedQueryData: { [key: string]: any } = {};

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['view']
  };

  actionEvent({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: any;
  }) {
    const { id, VendorId, ExemptVendorId, ClientRegisteredVendorId } = rowData;

    if (!VendorId && !ExemptVendorId && !ClientRegisteredVendorId) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot view vendor. Missing vendor ID.',
        { returnError: true }
      );
    }

    if (action === 'view') {
      if (VendorId) {
        this.router.navigate(['admin', 'vendor', VendorId, 'info']);
      }

      if (ExemptVendorId) {
        this.router.navigate([
          'admin',
          'exempt-vendor',
          ExemptVendorId,
          'info'
        ]);
      }

      if (ClientRegisteredVendorId) {
        this.router.navigate([
          'admin',
          'client-registered-vendor',
          ClientRegisteredVendorId,
          'info'
        ]);
      }
    }
  }
}
